import * as Sentry from '@sentry/browser';
import { actionNames } from '../modules/chat/actions';

const activeSpans = new Map();

const WS_ACTION_PAIRS = {
  [actionNames.FETCH_CHAT_REQUEST]: {
    success: actionNames.FETCH_CHAT_SUCCESS,
    failure: actionNames.FETCH_CHAT_FAILURE,
  },
  [actionNames.FETCH_MESSAGES_REQUEST]: {
    success: actionNames.FETCH_MESSAGES_SUCCESS,
    failure: actionNames.FETCH_MESSAGES_FAILURE,
  },
  [actionNames.FETCH_MORE_MESSAGES_REQUEST]: {
    success: actionNames.FETCH_MORE_MESSAGES_SUCCESS,
    failure: actionNames.FETCH_MORE_MESSAGES_FAILURE,
  },
  [actionNames.FETCH_MORE_CHATS_REQUEST]: {
    success: actionNames.FETCH_MORE_CHATS_SUCCESS,
    failure: actionNames.FETCH_MORE_CHATS_FAILURE,
  },
  [actionNames.SEND_MESSAGE]: {
    success: actionNames.SEND_MESSAGE_SUCCESS,
    failure: actionNames.SEND_MESSAGE_FAILURE,
  },
  [actionNames.TRANSFER_CHAT_REQUEST]: {
    success: actionNames.TRANSFER_CHAT_SUCCESS,
    failure: actionNames.TRANSFER_CHAT_FAILURE,
  },
  [actionNames.FINISH_CHAT_REQUEST]: {
    success: actionNames.FINISH_CHAT_SUCCESS,
    failure: actionNames.FINISH_CHAT_FAILURE,
  },
  [actionNames.FETCH_CONTACTS_REQUEST]: {
    success: actionNames.FETCH_CONTACTS_SUCCESS,
    failure: actionNames.FETCH_CONTACTS_FAILURE,
  },
  [actionNames.CREATE_CONTACT_REQUEST]: {
    success: actionNames.CREATE_CONTACT_SUCCESS,
    failure: actionNames.CREATE_CONTACT_FAILURE,
  },
  [actionNames.UPDATE_CONTACT_REQUEST]: {
    success: actionNames.UPDATE_CONTACT_SUCCESS,
    failure: actionNames.UPDATE_CONTACT_FAILURE,
  },
  [actionNames.DELETE_CONTACT_EXTERNAL_REQUEST]: {
    success: actionNames.DELETE_CONTACT_EXTERNAL_SUCCESS,
    failure: actionNames.DELETE_CONTACT_EXTERNAL_FAILURE,
  },
  [actionNames.FETCH_CONTACT_CONFIG_REQUEST]: {
    success: actionNames.FETCH_CONTACT_CONFIG_SUCCESS,
    failure: actionNames.FETCH_CONTACT_CONFIG_FAILURE,
  },
  [actionNames.MERGE_CONTACT_SEARCH]: {
    success: actionNames.MERGE_CONTACT_SEARCH_SUCCESS,
    failure: actionNames.MERGE_CONTACT_SEARCH_FAILURE,
  },
  [actionNames.MERGE_CONTACTS]: {
    success: actionNames.MERGE_CONTACTS_SUCCESS,
    failure: actionNames.MERGE_CONTACTS_FAILURE,
  },
  [actionNames.UNMERGE_CONTACTS]: {
    success: actionNames.UNMERGE_CONTACTS_SUCCESS,
    failure: actionNames.UNMERGE_CONTACTS_FAILURE,
  },
  [actionNames.FETCH_UNIQUE_CHAT_REQUEST]: {
    success: actionNames.FETCH_UNIQUE_CHAT_SUCCESS,
    failure: actionNames.FETCH_UNIQUE_CHAT_FAILURE,
  },
  [actionNames.FETCH_OPERATORS_LIST_REQUEST]: {
    success: actionNames.FETCH_OPERATORS_LIST_SUCCESS,
    failure: actionNames.FETCH_OPERATORS_LIST_FAILURE,
  },
  [actionNames.INSERT_TAG_TO_CONTACT_REQUEST]: {
    success: actionNames.INSERT_TAG_TO_CONTACT_SUCCESS,
    failure: actionNames.INSERT_TAG_TO_CONTACT_FAILURE,
  },
  [actionNames.PAYMENT_CHAT_REQUEST]: {
    success: actionNames.PAYMENT_CHAT_REQUEST_SUCCESS,
    failure: actionNames.PAYMENT_CHAT_REQUEST_FAILURE,
  },
  [actionNames.FETCH_CATALOG]: {
    success: actionNames.FETCH_CATALOG_SUCCESS,
    failure: actionNames.FETCH_CATALOG_FAILURE,
  },
  [actionNames.CREATE_SHOPPING_CART_REQUEST]: {
    failure: actionNames.CREATE_SHOPPING_CART_FAILURE,
  },
  [actionNames.UPDATE_SHOPPING_CART_REQUEST]: {
    failure: actionNames.UPDATE_SHOPPING_CART_FAILURE,
  },
  [actionNames.GET_PROTOCOL]: {
    success: actionNames.GET_PROTOCOL_SUCCESS,
    failure: actionNames.GET_PROTOCOL_FAILURE,
  },
  [actionNames.FETCH_OPPORTUNITIES_AND_TICKETS_REQUEST]: {
    success: actionNames.FETCH_OPPORTUNITIES_AND_TICKETS_SUCCESS,
    failure: actionNames.FETCH_OPPORTUNITIES_AND_TICKETS_FAILURE,
  },
  [actionNames.GET_CRM_TOKEN]: {
    success: actionNames.GET_CRM_TOKEN_SUCCESS,
    failure: actionNames.GET_CRM_TOKEN_FAILURE,
  },
  [actionNames.PAYMENT_CHAT_REQUEST]: {
    success: actionNames.PAYMENT_CHAT_REQUEST_SUCCESS,
    failure: actionNames.PAYMENT_CHAT_REQUEST_FAILURE,
  },
  [actionNames.FETCH_CHAT_CONFIG_REQUEST]: {
    success: actionNames.FETCH_CHAT_CONFIG_SUCCESS,
    failure: actionNames.FETCH_CHAT_CONFIG_FAILURE,
  },
  [actionNames.FETCH_USERS_REQUEST]: {
    success: actionNames.FETCH_USERS_SUCCESS,
    failure: actionNames.FETCH_USERS_FAILURE,
  },
  [actionNames.FETCH_PENDENCES_REQUEST]: {
    success: actionNames.FETCH_PENDENCES_CHATS_SUCCESS,
    failure: actionNames.FETCH_PENDENCES_CHATS_FAILURE,
  },
  [actionNames.CREATE_QUICK_MESSAGE]: {
    success: actionNames.CREATE_QUICK_MESSAGE_SUCCESS,
    failure: actionNames.CREATE_QUICK_MESSAGE_FAILURE,
  },
  [actionNames.UPDATE_QUICK_MESSAGE]: {
    success: actionNames.UPDATE_QUICK_MESSAGE_SUCCESS,
    failure: actionNames.UPDATE_QUICK_MESSAGE_FAILURE,
  },
  [actionNames.FETCH_QUICK_MESSAGES]: {
    success: actionNames.FETCH_QUICK_MESSAGES_SUCCESS,
    failure: actionNames.FETCH_QUICK_MESSAGES_FAILURE,
  },
  [actionNames.FETCH_SHOPPING_CART_DETAIL_REQUEST]: {
    failure: actionNames.FETCH_SHOPPING_CART_DETAIL_FAILURE,
  },
  [actionNames.DIDNT_REPLY]: {
    success: actionNames.DIDNT_REPLY_SUCCESS,
  },
};

const SPAN_TIMEOUT = 30000;

export const sentryWebSocketMiddleware = store => next => action => {
  const actionType = action.type;

  if (WS_ACTION_PAIRS[actionType]) {
    const requestId = `${actionType}_${Date.now()}`;

    const span = Sentry.startSpanManual(
      {
        name: actionType,
        op: 'websocket.request',
        attributes: {
          'action.type': actionType,
          'action.payload': JSON.stringify(action.payload || action.data || {}),
          'request.id': requestId,
        },
      },
      (span) => span
    );

    const timeoutId = setTimeout(() => {
      const spanData = activeSpans.get(requestId);
      if (spanData) {
        spanData.span.setStatus({ code: 2, message: 'Timeout' });
        spanData.span.end();
        activeSpans.delete(requestId);
      }
    }, SPAN_TIMEOUT);

    activeSpans.set(requestId, { span, timeoutId });
  }

  Object.entries(WS_ACTION_PAIRS).forEach(([requestType, { success, failure }]) => {
    if (actionType === success || actionType === failure) {
      const requestId = findMatchingRequestId(requestType);

      const spanData = activeSpans.get(requestId);

      if (spanData) {
        clearTimeout(spanData.timeoutId);

        spanData.span.setStatus({
          code: actionType === success ? 1 : 2,
          message: actionType === success ? 'Success' : 'Error',
        });

        spanData.span.setAttributes({
          'response.type': actionType,
          'response.success': actionType === success,
          ...(action.error && { 'error.message': String(action.error) }),
        });

        spanData.span.end();
        activeSpans.delete(requestId);
      }
    }
  });

  return next(action);
};

function findMatchingRequestId(requestType) {
  const matchingSpans = Array.from(activeSpans.entries())
    .filter(([id]) => id.startsWith(requestType));

  return matchingSpans.length > 0 ? matchingSpans[0][0] : `${requestType}_${Date.now()}`;
}
